import Vue from "vue";

import LoadingComponent from "@/components/LoadingComponent";
import SelectPaySectionComponent from "@/components/SelectPaySectionComponent";
import InputPaySectionComponent from "@/components/InputPaySectionComponent";
import PaySlipComponent from "@/components/PaySlipComponent";
import Calculator from "@/components/Calculator";
import TextFieldPaySection from "@/components/TextFieldPaySection";
import OrganizationalChartField from "@/components/OrganizationalChartField";
import OrganizationalChartSelect from "@/components/OrganizationalChartSelect";
import StrWorkerAutocomplete from "@/components/StrWorkerAutocomplete.vue";
import StrQuillEditor from "@/components/StrQuillEditor.vue";
import StrContratTemplateAutocomplete from "@/components/StrContratTemplateAutocomplete.vue";
import StrOccupationAutocomplete from "@/components/StrOccupationAutocomplete.vue";
import StrWorkerDefAutocomplete from "@/components/StrWorkerDefAutocomplete.vue";
import StrWorkflowStepAutocomplete from "@/components/StrWorkflowStepAutocomplete.vue"
import StrUserAutocomplete from "@/components/StrUserAutocomplete.vue"
import StrRoleAutocomplete from "@/components/StrRoleAutocomplete.vue"
import StrAbsenceReasonAutocomplete from "@/components/StrAbsenceReasonAutocomplete.vue"
import StrWorkFlowAutocomplete from "@/components/StrWorkFlowAutocomplete.vue"
import StrStepSelect from "@/components/StrStepSelect.vue"
import StrAllStepSelect from "@/components/StrAllStepSelect.vue"
import StrRecruitmentStateAutocomplete from "@/components/StrRecruitmentStateAutocomplete.vue"
import StrCnasAgencyAutocomplete from "@/components/StrCnasAgencyAutocomplete.vue";
import StrEvaluationFileAutocomplete from "@/components/StrEvaluationFileAutocomplete.vue";
import StrPerformanceAutocomplete from "@/components/StrPerformanceAutocomplete.vue";
import StrSkillAutocomplete from "@/components/StrSkillAutocomplete.vue";
import StrEvaluationGravityAutocomplete from "@/components/StrEvaluationGravityAutocomplete.vue";
import StrEvaluationPhaseAutocomplete from "@/components/StrEvaluationPhaseAutocomplete.vue";
import StrMedicalReasonAutocomplete from "@/components/StrMedicalReasonAutocomplete.vue";
import StrMedicalCenterAutocomplete from "@/components/StrMedicalCenterAutocomplete.vue";


Vue.component('str-worker-def-autocomplete', StrWorkerDefAutocomplete);
Vue.component('str-occupation-autocomplete', StrOccupationAutocomplete);
Vue.component('str-contrat-template-autocomplete', StrContratTemplateAutocomplete);
Vue.component('str-quill-editor', StrQuillEditor);
Vue.component('loading-component', LoadingComponent);
Vue.component('select-pay-section-component', SelectPaySectionComponent);
Vue.component('input-pay-section-component', InputPaySectionComponent);
Vue.component('pay-slip-component', PaySlipComponent);
Vue.component('calculator', Calculator);
Vue.component('text-field-pay-section', TextFieldPaySection);
Vue.component('organizational-chart-field', OrganizationalChartField);
Vue.component('organizational-chart-select', OrganizationalChartSelect);
Vue.component('str-worker-autocomplete', StrWorkerAutocomplete);
Vue.component('str-workflow-step-autocomplete', StrWorkflowStepAutocomplete);
Vue.component('str-user-autocomplete', StrUserAutocomplete);
Vue.component('str-role-autocomplete', StrRoleAutocomplete);
Vue.component('str-absence-reason-autocomplete', StrAbsenceReasonAutocomplete);
Vue.component('str-work-flow-autocomplete', StrWorkFlowAutocomplete);
Vue.component('str-step-select', StrStepSelect);
Vue.component('str-all-step-select', StrAllStepSelect);
Vue.component('str-recruitment-state-autocomplete', StrRecruitmentStateAutocomplete);
Vue.component('str-cnas-agcency-autocomplete', StrCnasAgencyAutocomplete);
Vue.component('str-evaluation-file-autocomplete', StrEvaluationFileAutocomplete);
Vue.component('str-performance-autocomplete', StrPerformanceAutocomplete);
Vue.component('str-skill-autocomplete', StrSkillAutocomplete);
Vue.component('str-evaluation-gravity-autocomplete', StrEvaluationGravityAutocomplete);
Vue.component('str-evaluation-phase-autocomplete', StrEvaluationPhaseAutocomplete);
Vue.component('str-medical-reason-autocomplete', StrMedicalReasonAutocomplete);
Vue.component('str-medical-center-autocomplete', StrMedicalCenterAutocomplete);